<template>
  <div class="bankDirectFlow">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/bankDirectFlow';
  // import DataBaseAPI from '@/api/dataBase';
  import { filterEmpty } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  // import loading from '@/common/js/load.js'; //loading
  import XEUtils from 'xe-utils';
  export default {
    name: 'bankDirectFlowList',
    mixins: [tableMixins],
    components: {},
    data() {
      return {
        query: {
          accountName: undefined, //公司银行名称
          startTradeAmount: undefined, //交易金额范围开始
          endTradeAmount: undefined, //交易金额范围结束
          tradeDate: null, //交易日期
          accountCodeLike: null, //公司银行账号
          toAccountName: null, //交易方名称
          bankTradeSerialLike: null, //银行交易流水号
          dcFlag: null, //交易方向  1-借-付款,2-贷-收款
          toAccountCodeLike: null, //交易方银行账号
        },
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'accountName', title: 'bankDirectFlowList.table.accountName', visible: true }, //公司银行账户名称
          /* { field: "accountBankName",title: "bankDirectFlowList.table.accountName", visible: true },//公司银行名称 */
          { field: 'accountCode', title: 'bankDirectFlowList.table.accountCode', visible: true }, //公司银行账号
          {
            field: 'tradeAmount',
            title: 'bankDirectFlowList.table.tradeAmount',
            visible: true,
            format: 'formatAmountRound',
          }, //交易金额
          {
            field: 'dcFlag',
            title: 'bankDirectFlowList.table.dcFlag',
            visible: true,
            dictType: 'dcFlag',
          }, //交易方向
          { field: 'tradeDate', title: 'bankDirectFlowList.table.tradeDate', visible: true }, //交易日期
          {
            field: 'toAccountName',
            title: 'bankDirectFlowList.table.toAccountName',
            visible: true,
          }, //交易方名称
          { field: 'toBranchName', title: 'bankDirectFlowList.table.toBranchName', visible: true }, //交易方银行名称
          {
            field: 'toAccountCode',
            title: 'bankDirectFlowList.table.toAccountCode',
            visible: true,
          }, //交易方银行账号
          {
            field: 'bankTradeSerial',
            title: 'bankDirectFlowList.table.bankTradeSerial',
            visible: true,
          }, //银行交易流水号
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          //公司银行名称
          /* {
          prop: "accountName",
          name: this.$t("bankDirectFlowList.search.accountName"),
          type: "searchTableSpec",
          searchType: 'bankAccount',
          isMultiple: true,
          placeholder: this.$t("bankDirectFlowList.search.accountNamePlaceholder"),
          extraData: {
            bankAccountStatus: "001",
            companyCode: this.userInfo.companyCode,
          },
          currentValue: this.query.accountName,
          changeMethod: "handleChangeBaseData"
        }, */
          //交易金额范围
          {
            type: 'inputRange',
            prop: ['startTradeAmount', 'endTradeAmount'],
            max: 99999999999999.99,
            min: -99999999999999.99,
            name: this.$t('bankDirectFlowList.search.tradeAmount'),
          },
          //交易日期
          {
            prop: 'tradeDate',
            name: this.$t('bankDirectFlowList.search.tradeDate'),
            type: 'date',
            placeholder: this.$t('bankDirectFlowList.search.tradeDatePlaceholder'),
          },
          //公司银行账号
          {
            type: 'input',
            prop: 'accountCodeLike',
            name: this.$t('bankDirectFlowList.search.accountCode'),
            apiData: { dictType: 'payment_method' },
            placeholder: this.$t('bankDirectFlowList.search.accountCodePlaceholder'),
            clearable: true,
          },
          //交易方名称
          {
            type: 'input',
            prop: 'toAccountName',
            name: this.$t('bankDirectFlowList.search.toAccountName'),
            apiData: { dictType: 'payment_type' },
            placeholder: this.$t('bankDirectFlowList.search.toAccountNamePlaceholder'),
            clearable: true,
          },
          //银行交易流水号
          {
            type: 'input',
            prop: 'bankTradeSerialLike',
            name: this.$t('bankDirectFlowList.search.bankTradeSerial'),
            apiData: { dictType: 'expense_type' },
            placeholder: this.$t('bankDirectFlowList.search.bankTradeSerialPlaceholder'),
            clearable: true,
          },
          //交易方向
          {
            type: 'dict',
            dictType: 'dcFlag',
            prop: 'dcFlag',
            placeholder: this.$t('bankDirectFlowList.search.dcFlagPlaceholder'),
            name: this.$t('bankDirectFlowList.search.dcFlag'),
          },
          //交易方银行账号
          {
            type: 'input',
            prop: 'toAccountCodeLike',
            name: this.$t('bankDirectFlowList.search.toAccountCode'),
            placeholder: this.$t('bankDirectFlowList.search.toAccountCodePlaceholder'),
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      //获取数据
      getData() {
        console.log('查询列表');
        let query = this.setSearchParams();
        // if(params.payeeNos){
        //   params.payeeNos = this.query.map(item => {
        //     return i.partnerCode
        //   })
        // }
        this.$axios.post(API.LIST_BANK_TRADE_DETAIL_BY_PAGE, filterEmpty(query)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const query = { ...this.query, pageSize, pageNum };
        if (query.payeeNos && query.payeeNos.length > 0) {
          const { partnerCode } = query.payeeNos[0];
          query.payeeNo = partnerCode;
          delete query.payeeNos;
        }
        if (query.supplyChainNos && query.supplyChainNos.length > 0) {
          const { supplierCode } = query.supplyChainNos[0];
          query.supplyChainNo = supplierCode;
          delete query.supplyChainNos;
        }
        return query;
      },
      // 选择公司
      handleChangeBaseData(val) {
        let res = val.val;
        if (res && res.length > 0) {
          this.query.accountName = res[0].bankName; // 公司银行名称
          this.query.accountCode = res[0].bankAccountNum; // 公司银行账号
        } else {
          this.query.accountName = null;
          this.query.accountCode = null;
        }
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'export') {
          this.export();
        }
      },

      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.EXPORT_BANK_TRADE_DETAIL}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.query;
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.EXPORT_BANK_TRADE_DETAIL}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
    },
  };
</script>
